module.exports = __webpack_public_path__ + "media/images/gift/gift-close-5da88d642173b527b188a92a0a9a0f56.png";